/**
 * Helpers to inject header + footer into a blank Unlayer design.
 * Used to auto-populate new pages with header and footer content.
 */

import { cloneDeep } from 'lodash';

function makeHeaderRow(templateRow, pageName, navItems) {
    const row = cloneDeep(templateRow);
    row.id = `hf_header_${ Date.now() }`;
    row.cells = [1];
    row.columns = [{
        id: `hf_col_header_${ Date.now() }`,
        contents: [{
            type: 'custom#header',
            values: {
                page: { pageName },
                nav: { navItems },
            },
        }],
        values: {
            backgroundColor: '',
            padding: '0px',
            border: {},
            borderRadius: '0px',
            _meta: { htmlID: 'u_column_hf_h', htmlClassNames: 'u_column' },
            deletable: true,
            locked: false
        }
    }];
    return row;
}

function makeFooterRow(templateRow, pageName) {
    const row = cloneDeep(templateRow);
    row.id = `hf_footer_${ Date.now() + 1 }`;
    row.cells = [1];
    row.columns = [{
        id: `hf_col_footer_${ Date.now() + 1 }`,
        contents: [{
            type: 'custom#footer',
            values: { page: { pageName } }
        }],
        values: {
            backgroundColor: '',
            padding: '0px',
            border: {},
            borderRadius: '0px',
            _meta: { htmlID: 'u_column_hf_f', htmlClassNames: 'u_column' },
            deletable: true,
            locked: false
        }
    }];
    return row;
}

/**
 * Takes a blank design JSON exported from Unlayer and returns a new design
 * with header as the first row and footer as the last row.
 *
 * @param {Object} blankDesign - Design JSON exported from Unlayer after loadBlank.
 * @param {string} pageName - Page label for the header/footer blocks.
 * @param {Array} navItems - Navigation items for the header ({label, url}).
 * @returns {Object} Design with header and footer rows injected.
 */
export function injectHeaderFooterIntoDesign(blankDesign, pageName, navItems) {
    const design = cloneDeep(blankDesign);
    const templateRow = design.body.rows[0] || {};

    const headerRow = makeHeaderRow(templateRow, pageName, navItems);
    const footerRow = makeFooterRow(templateRow, pageName);

    design.body.rows = [headerRow, ...design.body.rows, footerRow];

    design.counters.u_row += 2;
    design.counters.u_column += 2;

    return design;
}
